import type { I18nInstance } from '@affine/i18n';

export const MAIL_I18N_PREFIX = 'com.streamlain.mail';

export function mailText(
  i18n: I18nInstance,
  key: string,
  options?: Record<string, number | string>
) {
  return i18n.t(`${MAIL_I18N_PREFIX}.${key}`, options);
}
